import * as React from 'react';
import PageHeader from "./PageHeader";
import { usePageStyles } from "./styles";

interface IPageProps {
    children?: React.ReactNode;
    style?: React.CSSProperties;
}

const Body = ({
    children,
    style
}: IPageProps) => {
    const { classes } = usePageStyles();
    return (
        <div className={classes.body} style={style}>
            {children}
        </div>
    )
}

const Footer = ({
    children
}: IPageProps) => {
    const { classes } = usePageStyles();
    return (
        <div className={classes.footer}>
            {children}
        </div>
    )
}

const Page = ({
    children
}: IPageProps) => {

    const { classes } = usePageStyles();
    return (
        <div className={classes.wrapper}>
            {children}
        </div>
    )
};

Page.Header = PageHeader;
Page.Body = Body;
Page.Footer = Footer;

export default Page;